let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("gfpt4")).then(() => parcelRequire('idFH3'));